import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';

import { DataService } from '../data/data.service';
import { GET_ACTIVE_ORDER } from './active.service.graphql';
import {
  Customer,
  GetActiveCustomerQuery,
  GetActiveOrderQuery,
  Order,
  Query,
  SavedVehicle,
} from '../../../graphql/generated/generated-types';
import { isPlatformBrowser, Location } from '@angular/common';
import { StateService } from '../../state/old/state.service';
import { GET_ACTIVE_CUSTOMER } from './active-customer.graphql';
import { GET_ACTIVE_VEHICLE } from './active-vehicle.graphql';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedModificationService } from '../../../shared/services/selected-modification.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SaveSuggestedVehicleDialogComponent } from '../../../shared/dialogs/save-suggested-vehicle-dialog/save-suggested-vehicle-dialog.component';
import { VehicleTypeService } from '../../../shared/services/vehicle-type.service';
import { reloadCurrentComponent, reloadCurrentComponentAddingNewModificationId } from '../../../shared/utils/reload-current-navigation';

@Injectable({
  providedIn: 'root',
})
export class ActiveService {
  private platformId: {};
  activeOrder$: Observable<Order>;
  activeCustomer$: Observable<Customer>;

  activeVehicle$: Observable<SavedVehicle | null>;
  public suggestedVehicleDialogIsOpened: boolean = false;
  public activeVehicle: SavedVehicle | null;

  constructor(
    private dataService: DataService,
    private stateService: StateService,
    private selectedModificationService: SelectedModificationService,
    private dialogService: DialogService,
    private vehicleTypeService: VehicleTypeService,
    private router: Router,
    private locationService: Location
  ) {
    this.platformId = inject(PLATFORM_ID);
    if (isPlatformBrowser(this.platformId)) {
      this.activeOrder$ = merge(
        this.stateService.select((state) => state.activeOrderId),
        this.stateService.select((state) => state.signedIn)
      ).pipe(
        switchMap(() =>
          this.dataService
            .query<GetActiveOrderQuery>(
              GET_ACTIVE_ORDER,
              {},
              'cache-and-network'
            )
            .pipe(map(({ activeOrder }) => activeOrder as Order))
        )
      );

      this.activeCustomer$ = merge(
        this.stateService.select((state) => state.signedIn)
      ).pipe(
        switchMap(() =>
          this.dataService
            .query<GetActiveCustomerQuery>(
              GET_ACTIVE_CUSTOMER,
              {},
              'cache-and-network'
            )
            .pipe(map((data) => data.activeCustomer as Customer))
        )
      );

      this.activeVehicle$ = merge(
        this.stateService.select((state) => state.activeVehicleId),
        this.stateService.select((state) => state.signedIn)
      )
        .pipe(
          switchMap((activeVehicleId, signedIn) => {
            return this.dataService
              .query<Query>(GET_ACTIVE_VEHICLE, {}, 'network-only')
              .pipe(
                map((data) => {
                 // const isSelected = this.selectedModificationService.selectedModificationId;
                //  return isSelected ? data.activeVehicle as SavedVehicle : null;
                return data.activeVehicle || null;
                }),
                tap((activeVehicle) => {
                  this.activeVehicle = activeVehicle;
                  if (!activeVehicle && this.selectedModificationService.selectedModificationId) {
                    console.log("No active vehicle / Only selected modification");
                    if (!this.suggestedVehicleDialogIsOpened) {
                      this.openSaveSuggestedVehicleDialog();
                    }
                  } else if ((activeVehicle?.modificationId && this.selectedModificationService.selectedModificationId) && (Number(activeVehicle?.modificationId) !== Number(this.selectedModificationService.selectedModificationId))) {
                    // TO IMPROVE (Both when dialog appears and make that this.selectedModificationService.selectedModificationId would be always number)
                    console.log("Active vehicle / Different selected modification");
                    if (!this.suggestedVehicleDialogIsOpened) {
                      this.openSaveSuggestedVehicleDialog();
                    }

                  } else if(activeVehicle && !this.selectedModificationService.selectedModificationId){
                    console.warn("Only active vehicle / No selected modification");
                 
                    reloadCurrentComponentAddingNewModificationId(this.router, this.locationService, this.selectedModificationService, activeVehicle)
                  }
                })
              );
          })
        );
    }
  }

  private openSaveSuggestedVehicleDialog() {
    this.suggestedVehicleDialogIsOpened = true;
    const dialogRef: DynamicDialogRef = this.dialogService.open(SaveSuggestedVehicleDialogComponent,
      {
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'Save suggested vehicle',
        data: {
          modificationId: Number(this.selectedModificationService.selectedModificationId),
          vehicleType: this.vehicleTypeService.currentVehicleType
        },
      });

    dialogRef.onClose.subscribe((result) => {
      this.suggestedVehicleDialogIsOpened = false;
      if (result) {
        reloadCurrentComponent(this.router, this.stateService, this.locationService);
      }



    })
  }
}
